(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chec-hero-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chec-hero-video')) {
    customElements.define('chec-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video || this.observer) return;
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (!this.loaded) {
                this.video.querySelectorAll('source[data-src]').forEach(source => {
                  source.src = source.dataset.src;
                });
                this.loaded = true;
                this.video.load();
              }
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          }
        }, { rootMargin: '150px 0px', threshold: 0.01 });
        this.observer.observe(this.video);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
